import logo from './assets/img/logo-light.png'
import p_img_1 from './assets/img/portfolio-images/12.png'
import p_img_2 from './assets/img/portfolio-images/3.png'
import p_img_1_desc from './assets/img/portfolio-images/img_1_desc.png'
import {
    TopMenuBlock,
    HeaderBlock,
    AboutBlock,
    PortfolioBlock,
    TestimonialsBloc,
    ContactBlock,
    FooterBlock
} from './classes/blocksExtended'

export const model = [
// MENU
    new TopMenuBlock(
    {
      'about':'Про нас',
      'portfolio':'Наші послуги',
      'resume':'Відгуки',
      'contacts':'Контакти'
    }),

// MENU

//HEADER
  new HeaderBlock(
      logo,
      {
        tag: 'header',
        styles: {
          position:'relative',
          'min-height': '480px',
          'padding-top': '20px'
        },
        logoStyles: {
          width: '100px',
          height: 'auto',
          'padding': '0px 10px',
          margin: '0px 0px 0px 5vw',
        },
        h1:'Sk-TRANS',
        p:'Перевезення вантажів по Україні'
      }),
//HEADER

// ABOUT
    new AboutBlock({
        about_right:{
            h3: 'Транспортно-логістична компанія <strong style="text-transform:none;">Sk-TRANS УКРАЇНА</strong> гарантує доставку вашого вантажу до місця призначення цілим і неушкодженим, вчасно та без переплат.',
            p:[
                '',
                "<strong>Sk-TRANS УКРАЇНА</strong> - це професійна і злагоджена команда з більш ніж 10-ти річним досвідом роботи в сфері вантажоперевезеннь та логістики. "+ 
                "Наші логісти завжди на звязку для оперативного вирішення будь-яких питань. "+
                "У будь-який момент можна отримати детальну інформацію про те, де зараз перебуває вантаж. "+
                "Ми розрахуємо оптимальний і найбільш безпечний маршрут, щоб будь-який вантаж дістався до місця призначення вчасно, цілим і неушкодженим. "+
                "А також допоможемо оформити будь-яку необхідну документацію.",
                'Кожне замовлення на автомобільне перевезення вантажу контролюється персональним менеджерок, який несе відповідальність за організацію і виконання всіх необхідних адміністративних та підготовчих заходів.',
                'Замовивши транспорт у нас, Ви можете бути впевнені, що до Вашої заявки поставляться з усією відповідальністю і зроблять все можливе, щоб Ви залишилися задоволені співпрацею.',
                'Наша прозора і демократична цінова політика Вас приємно здивує. Ми впевнені, що звернувшись до нас одного разу, Ви, як і багато інших наших замовників, захочете надалі здійснювати вантажні перевезення тільки з нами!'
                ],
            },
        about_left:{
            h3: '',
            h2:'Переваги співпраці з Sk-TRANS:',
            ul:{
               item:[
                    'Підтримка 24/7',
                    'Конфіденційність і суворе дотримання інтересів та вимог Клієнтів',
                    'Особистий менеджер, який запропонує оптимальне рішення',
                    'Зрозуміла система ціноутворення, вигідні тарифи в форматі ціна / якість',
                    'Тільки надійний транспорт і професійні водії.',
                    'Виконання нестандартних завдань',
                    'Точна і оперативна інформація про хід Вашого вантажоперевезення',
                    'Надання супутніх перевезенню послуг',
                    ]
            },
            socials:{
                'paper-plane':'https://t.me/sk_trans',
                'instagram':'https://www.instagram.com/sk_trans.com.ua/',
                'truck':'https://lardi-trans.ua/user/16751245600/'
                }
            }
        }
        , {
        tag: 'section',
        id: 'about',
        classes: 'bg_light',
        h2:'Про компанію',
        p:'Sk-TRANS УКРАЇНА',

    }),
//ABOUT

// PORTFOLIO
    new PortfolioBlock(
[
        {
            category:'p_item category-0',
            img:p_img_1,
            img_2:p_img_1_desc,
            h3:'Вантажоперевезення',
            p:'Sk-TRANS допоможе вам перевезти що завгодно і куди завгодно, в будь-яку точку на карті України. Організуємо домашній переїзд або швидку доставку вантажу по всій території України',
            desc:'Вантажоперевезення по Україні є одним з основних напрямків діяльності компанії <a href="#" style="color="#2EA2CC;">Sk-TRANS УКРАЇНА</a>, '+
                ' і ми готові доставити за місцем призначення будь-які вантажі, у тому числі негабаритні, великогабаритні та важкі,'+
                ' маючи для цього прекрасну технічну базу і штат досвідчених фахівців.'+
                " Наша компанія в своєму розпорядженні має парк техніки, будь-яких об`ємів та тонажу, "+
                'тому вантажоперевезення по Україні недорого здійснюються оптимальним для Вашого вантажу транспортом, '+
                'з урахуванням всіх вимог з транспортування. '+
                'Вантажоперевезення здійснюються точно в строк, незалежно від погодних умов. '+
                'Наші клієнти оплачують тільки економічно обґрунтовані суми за надані послуги.'+
                '<br>'+
                '<br>'+
                'Некваліфікована організація вантажоперевезень може мати для Вас такі неприємні наслідки, '+
                'як недотримання строків договорів, юридичні проблеми при транспортуванні, '+
                'пошкодження цінних вантажів, що спричинить за собою фінансові втрати, '+
                'тому до вибору логістичної компанії потрібно поставитися дуже серйозно.'+
                'Вантажоперевезення від <a href="#" style="color="#2EA2CC;">Sk-TRANS</a> характеризуються високим рівнем відповідальності та безпеки,'+
                'що важливо при роботі з цінними вантажами.'+
                '<br>'+
                '<br>'+
                'Для більш вигідного вантажоперевезення по Україні є можливість замовити місце в збірному вантажі. '+
                'Це відмінний варіант для клієнтів, яким незручно оплачувати всю фуру цілком.'+
                '<br>'+
                '<br>'+
                'Злагоджена робота наших диспетчерів і менеджерів дозволяє нам виконувати вантажні перевезення по Україні недорого і в самі мінімальні терміни.'+
                '<br>'+
                '<br>'+
                'Якщо Вам необхідно швидко і якісно доставити будь-який вантаж за призначенням, '+
                'не хвилюючись про його збереження, звертайтеся в компанію <a href="#" style="color="#2EA2CC;">«Sk-TRANS УКРАЇНА»</a>, '+
                'і ви переконаєтеся в нашому професіоналізмі, оперативності та уважному ставленні до кожного клієнта. '+
                'За кожним нашим замовником закріплений персональний менеджер, '+
                'готовий дати вичерпну консультацію на кожному етапі вантажоперевезення.'+
                ''+
                'Компанія Sk-TRANS виконує вантажоперевезення по Україні недорого як для юридичних осіб, так і для фізичних. '+
                'З кожним клієнтом укладається договір на надання послуг, пунктів якого ми ретельно дотримуємось. '
        }
],
{
        tag: 'section',
        id: 'portfolio',
        classes: 'bg_light',//'bg_dark',
        h2:'Компетенції',
        p:'Наші послуги',
        filters:{
            //'.category-1':'Довантаження',
            //'.category-2':'Послуга 2'
        }
}),
//PORTFOLIO
  
//TESTIMONIALS
new TestimonialsBloc(
[
    {
        img:'https://cdn1.lardi-trans.com/upload/gallery/7c/b7c4/58503116e4b099fcaf8153f1_340x340.jpeg',
        strong:'АЛЬТТРАНССЕРВИС',
        who:'ООО Україна, Дніпро',
        p:'Благодарим за выполненную работу. Надёжный и ответственный перевозчик. Всем рекомендуем к сотрудничеству!',
        direction:'left'
    },
        {
        img:'https://cdn1.lardi-trans.com/upload/gallery/4da/aed6/5841b796e4b099fcaf811c8e_340x340.png',
        strong:'КРАВЧУК ПАВЕЛ АЛЕКСАНДРОВИЧ',
        who:'ФЛП Україна, Смела',
        p:'Спасибо перевозчику за отличную работу!',
        direction:'right'
    },
    {
        img:'https://cdn1.lardi-trans.com/upload/gallery/db/454f/551e50cce4b016890ca31047_340x340.jpeg',
        strong:'Він Єкспо',
        who:'ПП Україна, Вінниця',
        p:'Дякую,перевізнику, за працю! Рекомендую всім замовникам, як надійного перевізника! Успіхів вам у роботі!Сподіваюсь на співпрацю, Юрій.',
        direction:'left'
    },
        {
        img:'https://cdn1.lardi-trans.com/upload/gallery/154/76d0/55156695e4b05e556807d4bb_340x340.jpeg',
        strong:'КРАВЧУК ПАВЕЛ АЛЕКСАНДРОВИЧ',
        who:'ФЛП Україна, Вінниця',
        p:'Дякую за співпрацю. Відповідальний, порядний та надій перевізник. Успіху та процвітання, з повагою Альона Яремчук.',
        direction:'right'
    }
],
{
        tag: 'section',
        id: 'resume',
        classes: '',
        h2:'Відгуки',
        p:'Наші клієнти про нас'
}),
//TESTIMONIALS

//CONTACTS
new ContactBlock({
        address:'м.Луцьк, вул.Запорізька, 37',
        phone_work:'+380 (97) 919 5915',
        phone_seva:'+380 (68) 819 9191',
        phone_oleksandr:'+380 (95) 242 3280',
        //phone_georgyi:'+380 96 042 6268',
        email:'sktrans.com.ua@gmail.com'
    },
    {
        tag: 'section',
        id: 'contacts',
        classes: 'bg_dark',
        h2:'Контакти',
        p:'Звяжіться з нами, або залиште свої данні і ми Вам перетелефонуємо',

    }),
//CONTACTS

//FOOTER
new FooterBlock({
    copyright: '2021 Sk-Trans Україна',
    socials:{
        'paper-plane':'https://t.me/sk_trans',
        'instagram':'https://www.instagram.com/sk_trans.com.ua/',
        'truck':'https://lardi-trans.ua/user/16751245600/'
    }
},
    {
        tag: 'footer',
        id: 'footer',
        classes: 'bg_light',
    })
//FOOTER
]